import { render, staticRenderFns } from "./company-methodology.html?vue&type=template&id=661d1b61&scoped=true&"
import script from "./company-methodology.js?vue&type=script&lang=js&"
export * from "./company-methodology.js?vue&type=script&lang=js&"
import style0 from "./company-methodology.scss?vue&type=style&index=0&id=661d1b61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d1b61",
  null
  
)

export default component.exports